"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentChildRelationshipNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super('Parent child relationship not found');
    }
}
exports.default = ParentChildRelationshipNotFoundError;
//# sourceMappingURL=ParentChildRelationshipNotFoundError.js.map